import React, { useLayoutEffect, useState, useEffect } from "react";
import Drawer from '@mui/material/Drawer';
import { useDrawerContext } from "../../contexts/drawer-context";
import { usePermissionContext } from "../../contexts/permission-context";
import { useComponentContext } from "../../contexts/component-context";
import IconButton from '@mui/material/IconButton';
import Toolbar from "@mui/material/Toolbar";
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider, createTheme } from '@mui/material/styles';
// temp
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import { DRAWER_LIST } from "../../constants/menu";
import './drawer.scss';
import MenuCollapse from '../../images/irm-icon-collapse.svg';
import MenuExpand from '../../images/irm-icon-expand.svg';
import sharePermission from "../../Utils/sharePermission";
import {
  hasPermission
} from '../../Utils/Common';
import NoAccess from "../NoAccess/NoAccess";

const drawerWidth = 240;
const iconWidth = 70;

const theme = createTheme({
  transitions: {
    duration: {
      enteringScreen: 2000,
      leavingScreen: 100,
    }
  }
});
const CustomDrawer = () => {
  const { isOpened, toggleIsOpened } = useDrawerContext();
  const { setSelectedComponent } = useComponentContext();
  const { permissions } = usePermissionContext();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  

  const handleActiveTab = (index) => {
    setSelectedIndex(index);
  };
  const [open, setOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const [message, setMessage] = useState(sharePermission.initialState);

  useLayoutEffect(() => {
    sharePermission.subscribe(setMessage);
  }, []);

  useEffect(() => {
    let filteredDrawerList = DRAWER_LIST.filter((item) => hasPermission(permissions, item.permission));
    // console.log(filteredDrawerList);

    let defaultComponent = (filteredDrawerList.length && filteredDrawerList[0].component) || <NoAccess title={'Access Denied'} info={'Please check with site admin or contact support'}/>;
    //console.log("Default Component: ", defaultComponent);
    setSelectedComponent(defaultComponent);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Drawer
        variant="permanent"
        anchor={"left"}
        open={open}
        onClose={() => toggleIsOpened(!isOpened)}
        sx={{
          width: open ? drawerWidth : iconWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: open ? drawerWidth : iconWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        {/* <MenuItemsList /> */}
        <Grid>
          <List sx={{ padding: 0 }}>
            {DRAWER_LIST.map((item, index) => (
              <>
                {hasPermission(permissions, item.permission) && (
                  <ListItem button key={item.text} selected={selectedIndex === index} onClick={() => {
                    setSelectedComponent(item.component);
                    handleActiveTab(index);
                  }}>
                    <Tooltip title={open ? "" : item.text} arrow placement="right">
                      <ListItemIcon>
                        <item.icon />
                      </ListItemIcon>
                    </Tooltip>
                    <ListItemText primary={item.text} />
                  </ListItem>
                )}

              </>
            ))}
          </List>
          <List className="toogleButton">

            <Tooltip title={open ? "" : "Open"} arrow placement="right">
              <IconButton onClick={handleDrawerToggle}>
                {open ?
                  <img alt='menu collapse' src={MenuCollapse} style={{ 'height': '32px', width: '32px' }} />
                  :
                  <img alt='menu expand' src={MenuExpand} style={{ 'height': '32px', width: '32px' }} />
                }
              </IconButton>
            </Tooltip>
            <ListItemText primary={open ? "Collapse" : ""} />
          </List>
        </Grid>
      </Drawer>
    </ThemeProvider>
  );
}

export default CustomDrawer;